import { apis } from "../config";
import { Post } from "@/utils/request";
// 登录
export function toLogin(data){
    return Post(apis.login.login,data)
}
// 登出
export function toLogout(data={}){
    return Post(apis.login.logout,data)
}
// 获取用户信息
export function getUserInfo(data={}){
    return Post(apis.login.getUserInfo,data)
}

// 修改密码

export function changePassword(data){
    return Post(apis.login.changePwd,data)
}